// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import PrivateRoute from "../protectedRoute/PrivateRoute";
// import PublicRoute from "../protectedRoute/publicRoute";
// import Registration from "../pages/registration";
// // import Login from "../pages/login";
// // import Signup from "../pages/signup";
// import LandingPage from "../pages/landingPage";
// import EmailVerification from "../common/verification/emailVerification";
// import MobileVerification from "../pages/mobileVerification";
// // import CourseSelection from "../pages/courseSelection";
// import QueryList from "../pages/queryList";
// import EmailVerificationSuccess from "../common/verification/emailVerificationStatus";
// import MobileVerificationStatus from "../common/verification/mobileVerificationStatus";
// import RaiseQuery from "../pages/raiseQuery";
// // import PaymentReceiptList from "../pages/paymentReceiptList";
// import PaymentReceiptView from "../pages/paymentReceiptView";
// import { ForgetPassword } from "../pages/forgetPassword";
// import NewPasswordMail from "../pages/newPasswordMail";
// import ForgotPasswordStatus from "../common/verification/forgotpasswordStatus";
// import CandidateDetails from "../pages/candidateDetails";
// import CourseRegistration from "../pages/courseRegistration";
// import CourseSelection from "../pages/courseSelection";
// import PreRequestPage from "../pages/preRequestPage";
// import PaymentConfirmation from "../pages/paymentConfirmation";
// import Instruction from "../pages/instruction";
// import PaymentReciptList from "../pages/PaymentReciptList";
// import ObjectionTrackerDashboard from "../pages/ObjectionTrackerDashboard";
// import ObjectionTrackerView from "../pages/ObjectionTrackerView";
// import AnswerKey from "../pages/answerKeys";
// import AdmitCardList from "../pages/admitCardList";
// import AdmitCard from "../pages/admitCard";
// import ObjectionDetails from "../pages/objectionDetails";
// import BilldeskStatus from "../common/billdeskStatus";
// import VenueAllocation from "../common/venueAllocation";
// import PayUStatus from "../common/payuStatus";
// import ResetPassword from "../pages/resetPassword";
// import EditingFacility from "../pages/editingFacility";
// import ObjectionPaymentConfirmation from "../pages/ObjectionPaymentConfirmation";
// import ObjectionPayUStatus from "../common/ObjectionPayuStatus";
// import ObjectionBilldeskStatus from "../common/ObjectionbilldeskStatus";
// import ScoreCardList from "../pages/scoreCardList";
// import ScoreCard from "../pages/scoreCard";

// const CandidateRoutes = () => {
//   return (
//     <>
//       <Routes>
//       <Route path="" element={<LandingPage/>} />
//         {/* <Route path="" element={<PublicRoute><Login /></PublicRoute>} />
//         <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
//         <Route path="signup" element={<PublicRoute><Signup /></PublicRoute>} /> */}
//         <Route path="forgot-password" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
//         <Route path="verify-email" element={<PublicRoute><EmailVerification /></PublicRoute>} />
//         <Route path="email-verified-status" element={<PublicRoute><EmailVerificationSuccess /></PublicRoute>} />
//         <Route path="mobileno-verification" element={<PublicRoute><MobileVerificationStatus /></PublicRoute>} />
//         <Route path="new-password" element={<PublicRoute><NewPasswordMail /></PublicRoute>} />
//         <Route path="forgot-password-status" element={<PublicRoute><ForgotPasswordStatus /></PublicRoute>} />
//         <Route path="verify-mobileno" element={<MobileVerification />} />
//         <Route path="home" element={<LandingPage />} />
//         <Route path="registration" element={<Registration />} />
//         <Route path="candidate-details" element={<CandidateDetails />} />
//         <Route path="course-registration" element={<CourseRegistration/>}/>
//         {/* <Route path="course-selection" element={<CourseSelection />} /> */}
//         <Route path="course-selection" element={<CourseSelection />} />
//         <Route path="query-list" element={<QueryList />} />
//         <Route path="raise-query" element={<RaiseQuery />} />
//         <Route path="pre-request" element={<PreRequestPage/>} />
//         <Route path="confirm-payment" element={<PaymentConfirmation/>} />
//         <Route path="instruction" element={<Instruction/>} />
//         <Route path="payment-receipts" element={<PaymentReciptList />} />
//         <Route path="payment-receipt-view/:id" element={<PaymentReceiptView />} />
//         <Route path="objection-tracker" element={<ObjectionTrackerDashboard />} />
//         <Route path="objection-tracker-view" element={<ObjectionTrackerView />} />
//         <Route path="objection-details" element={<ObjectionDetails/>} />
//         <Route path="answer-key" element={<AnswerKey />} />
//         <Route path="pre-request" element={<PreRequestPage />} />
//         <Route path="confirm-payment" element={<PaymentConfirmation />} />
//         <Route path="objection-confirm-payment" element={<ObjectionPaymentConfirmation />} />
//         <Route path="billdesk-status" element={<BilldeskStatus />} />
//         <Route path="objection-billdesk-status" element={<ObjectionBilldeskStatus />} />
//         <Route path="venue-allocation" element={<VenueAllocation/>} />
//         <Route path="payu-status" element={<PayUStatus />} />
//         <Route path="objection-payu-status" element={<ObjectionPayUStatus />} />
//         <Route path="instruction" element={<Instruction />} />
//         <Route path="admit-card-list" element={<AdmitCardList/>} />
//         <Route path="score-card-list" element={<ScoreCardList/>} />

//         <Route path="admit-card" element={<AdmitCard/>} />
//         <Route path="score-card" element={<ScoreCard/>} />

//         <Route path="reset-password" element={<ResetPassword/>} />
//         <Route path="editing-facility" element={<EditingFacility />} />
//         {/* <Route path="payment-receipts" element={<PaymentReceiptList />} /> */}
//         {/* <Route path="payment-receipt-view" element={<PaymentReceiptView />} /> */}
//       </Routes>
//     </>
//   );
// };

// export default CandidateRoutes; 
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import PublicRoute from "../protectedRoute/publicRoute";
import RegistrationClosed from "../components/courseSelection/registrationClosed";
import InitialRender from "../components/courseSelection/initialRender";
import SuspenseLoader from "../common/suspenseLoader"
import PaymentPage from "../components/paymentConfirmation/PaymentPage";
const Registration = lazy(() => import("../pages/registration"));
const LandingPage = lazy(() => import("../pages/landingPage"));
const EmailVerification = lazy(() => import("../common/verification/emailVerification"));
// const MobileVerification = lazy(() => import("../pages/mobileVerification"));
const QueryList = lazy(() => import("../pages/queryList"));
const EmailVerificationSuccess = lazy(() => import("../common/verification/emailVerificationStatus"));
const MobileVerificationStatus = lazy(() => import("../common/verification/mobileVerificationStatus"));
const RaiseQuery = lazy(() => import("../pages/raiseQuery"));
const PaymentReceiptView = lazy(() => import("../pages/paymentReceiptView"));
const ForgetPassword = lazy(() => import("../pages/forgetPassword"));
const NewPasswordMail = lazy(() => import("../pages/newPasswordMail"));
const ForgotPasswordStatus = lazy(() => import("../common/verification/forgotpasswordStatus"));
const CandidateDetails = lazy(() => import("../pages/candidateDetails"));
const CourseRegistration = lazy(() => import("../pages/courseRegistration"));
const CourseSelection = lazy(() => import("../pages/courseSelection"));
const PreRequestPage = lazy(() => import("../pages/preRequestPage"));
const PaymentConfirmation = lazy(() => import("../pages/paymentConfirmation"));
const Instruction = lazy(() => import("../pages/instruction"));
const PaymentReciptList = lazy(() => import("../pages/PaymentReciptList"));
const ObjectionTrackerDashboard = lazy(() => import("../pages/ObjectionTrackerDashboard"));
const ObjectionTrackerView = lazy(() => import("../pages/ObjectionTrackerView"));
const AnswerKey = lazy(() => import("../pages/answerKeys"));
const AdmitCardList = lazy(() => import("../pages/admitCardList"));
const AdmitCard = lazy(() => import("../pages/admitCard"));
const ObjectionDetails = lazy(() => import("../pages/objectionDetails"));
const BilldeskStatus = lazy(() => import("../common/billdeskStatus"));
const VenueAllocation = lazy(() => import("../common/venueAllocation"));
const PayUStatus = lazy(() => import("../common/payuStatus"));
const ResetPassword = lazy(() => import("../pages/resetPassword"));
const EditingFacility = lazy(() => import("../pages/editingFacility"));
const ObjectionPaymentConfirmation = lazy(() => import("../pages/ObjectionPaymentConfirmation"));
const ObjectionPayUStatus = lazy(() => import("../common/ObjectionPayuStatus"));
const ObjectionBilldeskStatus = lazy(() => import("../common/ObjectionbilldeskStatus"));
const ScoreCardList = lazy(() => import("../pages/scoreCardList"));
const ScoreCard = lazy(() => import("../pages/scoreCard"));
const CapRegistartion = lazy(() => import("../pages/capRegistration"));
const CapCourseRegistration = lazy(() => import("../pages/capcourseRegistration"));
const AirPaySuccess=lazy(()=>import("../components/courseRegistration/airPaySuccess"))
const AirPayFailure=lazy(()=>import("../components/courseRegistration/airPayFailure"))


const CandidateRoutes = () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Routes>
        
        <Route element={<PublicRoute />}>
        <Route path="forgot-password" element={<ForgetPassword />} />
        <Route path="verify-email" element={<EmailVerification />} />
        <Route path="email-verified-status" element={<EmailVerificationSuccess />} />
        <Route path="mobileno-verification" element={<MobileVerificationStatus />} />
        <Route path="new-password" element={<NewPasswordMail />} />
        <Route path="forgot-password-status" element={<ForgotPasswordStatus />} />
        </Route>
        {/* <Route path="verify-mobileno" element={<MobileVerification />} /> */}
        <Route path="" element={<LandingPage />} />
        <Route path="home" element={<LandingPage />} />
        <Route path="/payment-airpay" element={<PaymentPage/>} />
        <Route element={<PrivateRoute />}>
        
        <Route path="registration" element={<Registration />} />
        <Route path="candidate-details" element={<CandidateDetails />} />
        <Route path="course-registration" element={<CourseRegistration />} />
        
        <Route path="course-selection" element={<CourseSelection />} />
        <Route path="cap-registration" element={<CapRegistartion />} />
        <Route path="query-list" element={<QueryList />} />
        <Route path="raise-query" element={<RaiseQuery />} />
        <Route path="pre-request" element={<PreRequestPage />} />
        <Route path="confirm-payment" element={<PaymentConfirmation />} />
        <Route path="instruction" element={<Instruction />} />
        <Route path="payment-receipts" element={<PaymentReciptList />} />
        <Route path="payment-receipt-view/:id" element={<PaymentReceiptView />} />
        <Route path="objection-tracker" element={<ObjectionTrackerDashboard />} />
        <Route path="objection-tracker-view" element={<ObjectionTrackerView />} />
        <Route path="objection-details" element={<ObjectionDetails />} />
        <Route path="answer-key" element={<AnswerKey />} />
        <Route path="objection-confirm-payment" element={<ObjectionPaymentConfirmation />} />
        <Route path="billdesk-status" element={<BilldeskStatus />} />
        <Route path="objection-billdesk-status" element={<ObjectionBilldeskStatus />} />
        <Route path="venue-allocation" element={<VenueAllocation />} />
        <Route path="payu-status" element={<PayUStatus />} />
        <Route path="air-pay/success" element={<AirPaySuccess />} />
         <Route path="air-pay/failure" element={<AirPayFailure />} />
        <Route path="objection-payu-status" element={<ObjectionPayUStatus />} />
        <Route path="admit-card-list" element={<AdmitCardList />} />
        <Route path="score-card-list" element={<ScoreCardList />} />
        <Route path="admit-card" element={<AdmitCard />} />
        <Route path="score-card" element={<ScoreCard />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="editing-facility" element={<EditingFacility />} />
        <Route path="cap-landingpage" element={<CapCourseRegistration />} />
        <Route path="registrations" element={<RegistrationClosed/>} />
        <Route path="initial-render" element={<InitialRender/>} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default CandidateRoutes;
